// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__zkiNR","icon":"NavLink_icon__-danN","active":"NavLink_active__z1WGS","navMenuLink":"NavLink_navMenuLink__6SH8H","counter":"NavLink_counter__k+CbJ"};